/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTAXREASON = {
    Par2B: 'PAR2',
    Irp3: 'IRP3',
    FixedRate: 'FR',
    Art18DoubleTaxation: 'ART18',
    Correction: 'COR',
    Section9: 'S9',
    Paye: 'PAYE'
} as const;
export type IAPTAXREASON = typeof IAPTAXREASON[keyof typeof IAPTAXREASON];


export function IAPTAXREASONFromJSON(json: any): IAPTAXREASON {
    return IAPTAXREASONFromJSONTyped(json, false);
}

export function IAPTAXREASONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTAXREASON {
    return json as IAPTAXREASON;
}

export function IAPTAXREASONToJSON(value?: IAPTAXREASON | null): any {
    return value as any;
}

